(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('.footer-redesign__col-toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var col = toggle.closest('.footer-redesign__col');
      var footer = toggle.closest('.footer-redesign');
      var isOpen = col.classList.contains('footer-redesign__col--open');

      col.classList.toggle('footer-redesign__col--open', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));

      var anyOpen = footer.querySelectorAll('.footer-redesign__col--open').length > 0;
      footer.classList.toggle('footer-redesign--expanded', anyOpen);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
